import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {useAppDispatch} from 'core/redux/hooks/useAppDispatch';
import {selectIsCityApplied} from 'modules/locations/selectors';
import {useEffect} from 'react';
import {actionSetPortalHidden, actionSetPortalVisible} from 'modules/portal/slice';
import {MODALS} from 'modules/modals/constants';

export const useCityClarification = () => {
    const dispatch = useAppDispatch();
    const isCityApplied = useAppSelector(selectIsCityApplied);

    useEffect(() => {
        if (isCityApplied) {
            dispatch(actionSetPortalHidden(MODALS.CITY_CLARIFICATION.name));
            return;
        }

        dispatch(actionSetPortalVisible(MODALS.CITY_CLARIFICATION.name));
    }, [dispatch, isCityApplied]);
};
